<!--文章-->
<template>
	<div class="page-body center-wrap">
		<div class="navBar cur-poi" @click="$nav.back()">
			<i class="el-icon-arrow-left"></i>
			{{ info.title }}
		</div>
		<div class="pad-20 txt-16" v-html="info.content">
		</div>
	</div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import { getQueryParam } from '@/common/public.js';
export default {
	components: {},
	data() {
		return {
			info: {}
		};
	},
	created() {
		this.getData()
		console.log(getQueryParam('type'), 11)
	},
	beforeUnmount() { },
	methods: {
		getData() {
			let type = getQueryParam('type') || 7
			get(apis.richtextGetInfo, { type }).then(res => {
				if (res.code != 1) return
				this.info = res.data
			})
		}
	},
};
</script>
<style lang="scss" scoped>
.page-body {

	padding: 20px 0px;
	font-size: 14px;

	.navBar {
		padding: 15px 10px;
		font-size: 18px;
		font-weight: 700;
		border-radius: 4px;
	}
}
</style>